var stores = [];
var selected_store = [];
var infoWindow = [];

//Sort stores alpha
function storesSorted(stores) {
  return stores.sort(function(a, b) {
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    return 0;
  });
}

//Get stores as JSON from the API
var getStoresLocations = function() {
  var xhr = new XMLHttpRequest();
  xhr.open("GET", "https://api.ismash.com/app/stores", true);
  //xhr.open("GET", "https://api.ismash.com/app/stores", true); 
  xhr.onload = function() {
    var data = JSON.parse(xhr.responseText);
    var store = data;
    console.log("stores "+store);
    var alphastorelist = storesSorted(store);

    for (var i = 0; i < alphastorelist.length; i++) {
      var thisstore = alphastorelist[i];
      thisstore.address = thisstore.address.replace("'","")
      if (thisstore.latitude && thisstore.in_london == 1) {
        var storeHTML =
          "<div class='col-xs-12 col-md-6' onclick='viewStore(" +
          JSON.stringify(thisstore) +
          "," +
          thisstore.latitude +
          "," +
          thisstore.longitude +
          ")'>" +
          '<span class="repair--storeLocation-title">' +
          thisstore.name +
          ' <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>' +
          "</span>" +
          "</div>";
        $(".london-storemaps").append(storeHTML);
      }

      if (thisstore.latitude && thisstore.in_london == 0) {
        var storeHTML2 =
          "<div class='col-xs-12 col-md-6' onclick='viewStore(" +
          JSON.stringify(thisstore) +
          "," +
          thisstore.latitude +
          "," +
          thisstore.longitude +
          ")'>" +
          '<span class="repair--storeLocation-title">' +
          thisstore.name +
          ' <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>' +
          "</span>" +
          "</div>";
        $(".other-storemaps").append(storeHTML2);
      }
      console.log(thisstore.name+' '+thisstore.latitude+' '+thisstore.longitude);
    }

    stores = data;
    mapInit();
    $(".ajax-spinner").hide();
    $(".storeLocation-selection").show();
  };
  xhr.send();
};

//Store search by postcode
$("#searchPostcode").submit(function(e) {
  e.preventDefault();
  gotoNearestStoreLocation($("#postcode").val(), stores);

  scrollTo("#searchPostcode");
});

//Store search by postcode - mobile
$("#searchPostcodeMobile").submit(function(e) {
  e.preventDefault();
  gotoNearestStoreLocation($("#postcodemobile").val(), stores);

  scrollTo("#searchPostcodeMobile");
});

//Get the user postcode and go to nearest store
var gotoNearestStoreLocation = function() {
  if (infoWindow.length != 0) {
    infoWindow.close();
  }
  var userPostcode = document.getElementById("postcode").value;
  if(!userPostcode){
    userPostcode = document.getElementById("postcodemobile").value;
  }

  $.get(
    "https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyBa2bxAi5-ZjZ30Pxp9PPl94Dgin8Sottw&address=" +
      userPostcode +
      ", GB"
  ).then(
    function(data) {
      var userLocation = data.results[0].geometry.location;
      userLocation = new google.maps.LatLng(userLocation.lat, userLocation.lng);

      var nearestStore = null;
      var nearestStoreDistance = null;

      for (var i = 0; i < stores.length; i++) {
        var storeLocation = new google.maps.LatLng(
          stores[i].latitude,
          stores[i].longitude
        );
        var currentStoreDistance = google.maps.geometry.spherical.computeDistanceBetween(
          userLocation,
          storeLocation
        );

        if (
          !nearestStoreDistance ||
          currentStoreDistance < nearestStoreDistance
        ) {
          nearestStore = stores[i];
          nearestStoreDistance = currentStoreDistance;
        }
      }
      var storeDetailsWrap = document.createElement("div");
      var lineBreak = document.createElement("br");

      var storeDetails = document.createElement("p");

      var storeName = document.createElement("b");
      storeName.textContent = nearestStore.name;
      storeDetails.appendChild(storeName);
      storeDetails.appendChild(lineBreak);

      var storeAddress = document.createElement("p");
      storeAddress.textContent = nearestStore.address;
      storeDetails.appendChild(storeAddress);
      storeDetails.appendChild(lineBreak);

      var storePhone = document.createElement("p");
      storePhone.textContent = nearestStore.contact_phone;
      storeDetails.appendChild(storePhone);
      storeDetails.appendChild(lineBreak);

      var selectStore = document.createElement('a');
      selectStore.classList.add('btn');
      if (nearestStore.name == 'Devonshire Square') {
        selectStore.href = 'https://www.ismash.com/pages/ismash-devonshire-square';
      }
      if (nearestStore.name == 'Birmingham') {
        selectStore.href = 'https://www.ismash.com/pages/ismash-birmingham-colmore-row';
      }
      if (nearestStore.name == ' Birmingham') {
        selectStore.href = 'https://www.ismash.com/pages/ismash-birmingham-colmore-row';
      }
      if (nearestStore.name == 'Liverpool Derby Square') {
        selectStore.href = 'https://www.ismash.com/pages/ismash-liverpool-derby-square';
      }
      if(nearestStore.name=='Bank Station'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-bank-underground-station-phone-repairs';
      }
    
      if(nearestStore.name=='Bond Street Station'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-bond-street-station-phone-repairs';
      }
      
      if(nearestStore.name=='Broadgate'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-broadgate-circle-phone-repairs';
      }
      
      if(nearestStore.name=='Canary Wharf'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-canary-wharf-store-phone-repairs';
      }
      
      if(nearestStore.name=='Charing Cross'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-charing-cross-phone-repairs';
      }
      
      if(nearestStore.name=='Chiswick'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-chiswick-walk-in-centre';
      }
      
      if(nearestStore.name=='Covent Garden'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-covent-garden-phone-repairs';
      }
      
      if(nearestStore.name=='Croydon'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-croydon';
      }
      
      if(nearestStore.name=='Fleet Street'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-fleet-street-phone-repairs';
      }
      
      if(nearestStore.name=='High Street Kensington'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-high-street-kensington-phone-repairs';
      }
      
      if(nearestStore.name=='Kings Road'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-kings-road-phone-repairs';
      }
      
      if(nearestStore.name=='Kingston'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-kingston-phone-repairs';
      }
      
      if(nearestStore.name=='Lakeside'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-lakeside-phone-repairs';
      }
      
      if(nearestStore.name=='Oxford Circus Station'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-oxford-circus-station-phone-repairs';
      }
      
      if(nearestStore.name=='St Pancras'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-st-pancras-phone-repairs';
      }
      
      if(nearestStore.name=='Tottenham Court Road'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-tottenham-court-road-phone-repairs';
      }
      
      if(nearestStore.name=='Victoria Station'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-victoria-station-phone-repairs';
      }
      
      if(nearestStore.name=='Westfield Stratford City'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-westfield-stratford-city-phone-repairs';
      }
      
      if(nearestStore.name=='Westfield White City'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-westfield-white-city-phone-repairs';
      }
      
      if(nearestStore.name=='Bluewater'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-bluewater-store-phone-repairs';
      }
      
      if(nearestStore.name==' Harrow'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-harrow';
      }
      
      if(nearestStore.name=='Brighton Churchill Square'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-brighton-churchill-square-phone-repair';
      }
      
      if(nearestStore.name=='Bristol Broadmead'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-bristol-broadmead-phone-repairs';
      }
      
      if(nearestStore.name=='Guildford'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-guildford-phone-repairs';
      }
      
      if(nearestStore.name=='Leeds Trinity Centre'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-leeds-trinity-phone-repairs';
      }
      
      if(nearestStore.name=='Manchester Arndale Centre'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-manchester-arndale-phone-repairs';
      }
      
      if(nearestStore.name=='Sheffield Meadowhall Centre'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-sheffield-meadowhall-centre-phone-repairs';
      }
      
      if(nearestStore.name=="Cardiff St Davids (Sky)"){
        selectStore.href = 'https://www.ismash.com/pages/ismash-cardiff-st-davids-sky';
      }
      
      if(nearestStore.name=='Liverpool One (Sky)'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-liverpool-one';
      }
      
      if(nearestStore.name=='London Bridge Station'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-london-bridge';
      }
      
      if(nearestStore.name=='Glasgow Buchanan St (Sky)'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-glasgow-buchanan-street';
      }
      
      if(nearestStore.name==' Nottingham'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-nottingham-king-street';
      }
      
      if(nearestStore.name=='Bristol Cribbs Causeway (Sky)'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-bristol-cribbs';
      }
      
      if(nearestStore.name=='Edinburgh St James (Sky)'){
        selectStore.href = 'https://www.ismash.com/pages/ismash-edinburgh-princes-street';
      }
    
      selectStore.textContent = "View details";
      storeDetails.appendChild(selectStore);

      storeDetailsWrap.appendChild(storeDetails);

      infoWindow = new google.maps.InfoWindow({
        content: storeDetailsWrap
      });

      var marker = createStoreMarker(nearestStore);
      map.setZoom(15);
      map.setCenter(marker.getPosition());
      infoWindow.open(self.map, marker);
    },
    function(data) {
      console.error(data);
    }
  );
  google.maps.event.addListener(infoWindow, "closeclick", function() {
    self.map.setZoom(6);
    self.map.setCenter({
      lat: 52.7040556,
      lng: -1.6913345
    });
  });
};

var viewStore = function(store, storeLat, storeLong) {
  console.log("viewStore runs "+store.name+" "+storeLat+" "+storeLong);
  if (infoWindow.length != 0) {
    infoWindow.close();
  }
  var storeDetailsWrap = document.createElement("div");
  var lineBreak = document.createElement("br");

  var storeDetails = document.createElement("p");

  var storeName = document.createElement("b");
  storeName.textContent = store.name;
  storeDetails.appendChild(storeName);
  storeDetails.appendChild(lineBreak);

  var storeAddress = document.createElement("p");
  storeAddress.textContent = store.address;
  storeDetails.appendChild(storeAddress);
  storeDetails.appendChild(lineBreak);

  var storePhone = document.createElement("p");
  storePhone.textContent = store.contact_phone;
  storeDetails.appendChild(storePhone);
  storeDetails.appendChild(lineBreak);

  // var directionLink = document.createElement('a');
  // directionLink.href = 'https://www.google.com/maps/dir//' + encodeURIComponent(store.address);
  // directionLink.setAttribute("target", "_blank");
  // directionLink.textContent = "Get Directions";
  // storeDetails.appendChild(directionLink);
  // storeDetails.appendChild(lineBreak);

  var selectStore = document.createElement('a');
  selectStore.classList.add('btn');
  if (store.name == 'Devonshire Square') {
    selectStore.href = 'https://www.ismash.com/pages/ismash-devonshire-square';
  }

  if (store.name == 'Birmingham') {
    selectStore.href = 'https://www.ismash.com/pages/ismash-birmingham-colmore-row';
  }

  if (store.name == 'Liverpool Derby Square') {
    selectStore.href = 'https://www.ismash.com/pages/ismash-liverpool-derby-square';
  }
  if (store.name == ' Devonshire Square') {
    selectStore.href = 'https://www.ismash.com/pages/ismash-devonshire-square';
  }

  if (store.name == ' Birmingham') {
    selectStore.href = 'https://www.ismash.com/pages/ismash-birmingham-colmore-row';
  }

  if (store.name == ' Liverpool Derby Square') {
    selectStore.href = 'https://www.ismash.com/pages/ismash-liverpool-derby-square';
  }

  if(store.name=='Bank Station'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-bank-underground-station-phone-repairs';
  }

  if(store.name=='Bond Street Station'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-bond-street-station-phone-repairs';
  }
  
  if(store.name=='Broadgate'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-broadgate-circle-phone-repairs';
  }
  
  if(store.name=='Canary Wharf'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-canary-wharf-store-phone-repairs';
  }
  
  if(store.name=='Charing Cross'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-charing-cross-phone-repairs';
  }
  
  if(store.name=='Chiswick'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-chiswick-walk-in-centre';
  }
  
  if(store.name=='Covent Garden'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-covent-garden-phone-repairs';
  }
  
  if(store.name=='Croydon'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-croydon';
  }
  
  if(store.name=='Fleet Street'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-fleet-street-phone-repairs';
  }
  
  if(store.name=='High Street Kensington'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-high-street-kensington-phone-repairs';
  }
  
  if(store.name=='Kings Road'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-kings-road-phone-repairs';
  }
  
  if(store.name=='Kingston'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-kingston-phone-repairs';
  }
  
  if(store.name=='Lakeside'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-lakeside-phone-repairs';
  }
  
  if(store.name=='Oxford Circus Station'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-oxford-circus-station-phone-repairs';
  }
  
  if(store.name=='St Pancras'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-st-pancras-phone-repairs';
  }
  
  if(store.name=='Tottenham Court Road'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-tottenham-court-road-phone-repairs';
  }
  
  if(store.name=='Victoria Station'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-victoria-station-phone-repairs';
  }
  
  if(store.name=='Westfield Stratford City'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-westfield-stratford-city-phone-repairs';
  }
  
  if(store.name=='Westfield White City'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-westfield-white-city-phone-repairs';
  }
  
  if(store.name=='Bluewater'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-bluewater-store-phone-repairs';
  }
      
  if(store.name==' Harrow'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-harrow';
  }
  
  if(store.name=='Brighton Churchill Square'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-brighton-churchill-square-phone-repair';
  }
  
  if(store.name=='Bristol Broadmead'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-bristol-broadmead-phone-repairs';
  }
  
  if(store.name=='Guildford'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-guildford-phone-repairs';
  }
  
  if(store.name=='Leeds Trinity Centre'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-leeds-trinity-phone-repairs';
  }
  
  if(store.name=='Manchester Arndale Centre'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-manchester-arndale-phone-repairs';
  }
  
  if(store.name=='Sheffield Meadowhall Centre'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-sheffield-meadowhall-centre-phone-repairs';
  }
      
  if(store.name=="Cardiff St Davids (Sky)"){
    selectStore.href = 'https://www.ismash.com/pages/ismash-cardiff-st-davids-sky';
  }
  
  if(store.name=='Liverpool One (Sky)'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-liverpool-one';
  }
  
  if(store.name=='London Bridge Station'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-london-bridge';
  }
  
  if(store.name=='Glasgow Buchanan St (Sky)'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-glasgow-buchanan-street';
  }
  
  if(store.name==' Nottingham'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-nottingham-king-street';
  }
  
  if(store.name=='Bristol Cribbs Causeway (Sky)'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-bristol-cribbs';
  }
  
  if(store.name=='Edinburgh St James (Sky)'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-edinburgh-princes-street';
  }

  selectStore.textContent = "View details";
  storeDetails.appendChild(selectStore);

  storeDetailsWrap.appendChild(storeDetails);

  infoWindow = new google.maps.InfoWindow({
    content: storeDetailsWrap
  });

  self.map.setZoom(12);
  self.map.setCenter({
    lat: storeLat,
    lng: storeLong
  });

  var marker = new google.maps.Marker({
    position: {
      lat: store.latitude,
      lng: store.longitude
    },
    map: this.map,
    icon: {
      url: "//www.ismash.com/cdn/shop/files/marker2.png?v=5410585011668452327"
    }
  });

  infoWindow.open(self.map, marker);

  //   google.maps.event.addListener(infoWindow, "closeclick", function() {
  //     self.map.setZoom(6);
  //     self.map.setCenter({
  //       lat: 52.7040556,
  //       lng: -1.6913345
  //     });
  //   });
  if ($(window).width() > 580) {
    var elmnt = document.getElementById("mobilemap");
    elmnt.scrollIntoView();
  }
};

//Create a marker for each store
var createStoreMarker = function(store) {
  var marker = new google.maps.Marker({
    position: {
      lat: store.latitude,
      lng: store.longitude
    },
    map: this.map,
    icon: {
      url: "//www.ismash.com/cdn/shop/files/marker2.png?v=5410585011668452327"
    }
  });

  var storeDetailsWrap = document.createElement("div");
  var lineBreak = document.createElement("br");

  var storeDetails = document.createElement("p");

  var storeName = document.createElement("b");
  storeName.textContent = store.name;
  storeDetails.appendChild(storeName);
  storeDetails.appendChild(lineBreak);

  var storeAddress = document.createElement("p");
  storeAddress.textContent = store.address;
  storeDetails.appendChild(storeAddress);
  storeDetails.appendChild(lineBreak);

  var storePhone = document.createElement("p");
  storePhone.textContent = store.contact_phone;
  storeDetails.appendChild(storePhone);
  storeDetails.appendChild(lineBreak);

  var selectStore = document.createElement('a');
  selectStore.classList.add('btn');
  if (store.name == 'Devonshire Square') {
    selectStore.href = 'https://www.ismash.com/pages/ismash-devonshire-square';
  }

  if (store.name == 'Birmingham') {
    selectStore.href = 'https://www.ismash.com/pages/ismash-birmingham-colmore-row';
  }

  if (store.name == 'Liverpool Derby Square') {
    selectStore.href = 'https://www.ismash.com/pages/ismash-liverpool-derby-square';
  }
  if (store.name == ' Devonshire Square') {
    selectStore.href = 'https://www.ismash.com/pages/ismash-devonshire-square';
  }

  if (store.name == ' Birmingham') {
    selectStore.href = 'https://www.ismash.com/pages/ismash-birmingham-colmore-row';
  }

  if (store.name == ' Liverpool Derby Square') {
    selectStore.href = 'https://www.ismash.com/pages/ismash-liverpool-derby-square';
  }
  
  if(store.name=='Bank Station'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-bank-underground-station-phone-repairs';
  }

  if(store.name=='Bond Street Station'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-bond-street-station-phone-repairs';
  }
  
  if(store.name=='Broadgate'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-broadgate-circle-phone-repairs';
  }
  
  if(store.name=='Canary Wharf'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-canary-wharf-store-phone-repairs';
  }
  
  if(store.name=='Charing Cross'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-charing-cross-phone-repairs';
  }
  
  if(store.name=='Chiswick'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-chiswick-walk-in-centre';
  }
  
  if(store.name=='Covent Garden'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-covent-garden-phone-repairs';
  }
  
  if(store.name=='Croydon'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-croydon';
  }
  
  if(store.name=='Fleet Street'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-fleet-street-phone-repairs';
  }
  
  if(store.name=='High Street Kensington'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-high-street-kensington-phone-repairs';
  }
  
  if(store.name=='Kings Road'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-kings-road-phone-repairs';
  }
  
  if(store.name=='Kingston'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-kingston-phone-repairs';
  }
  
  if(store.name=='Lakeside'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-lakeside-phone-repairs';
  }
  
  if(store.name=='Oxford Circus Station'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-oxford-circus-station-phone-repairs';
  }
  
  if(store.name=='St Pancras'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-st-pancras-phone-repairs';
  }
  
  if(store.name=='Tottenham Court Road'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-tottenham-court-road-phone-repairs';
  }
  
  if(store.name=='Victoria Station'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-victoria-station-phone-repairs';
  }
  
  if(store.name=='Westfield Stratford City'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-westfield-stratford-city-phone-repairs';
  }
  
  if(store.name=='Westfield White City'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-westfield-white-city-phone-repairs';
  }
  
  if(store.name=='Bluewater'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-bluewater-store-phone-repairs';
  }
      
  if(store.name==' Harrow'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-harrow';
  }
  
  if(store.name=='Brighton Churchill Square'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-brighton-churchill-square-phone-repair';
  }
  
  if(store.name=='Bristol Broadmead'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-bristol-broadmead-phone-repairs';
  }
  
  if(store.name=='Guildford'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-guildford-phone-repairs';
  }
  
  if(store.name=='Leeds Trinity Centre'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-leeds-trinity-phone-repairs';
  }
  
  if(store.name=='Manchester Arndale Centre'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-manchester-arndale-phone-repairs';
  }
  
  if(store.name=='Sheffield Meadowhall Centre'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-sheffield-meadowhall-centre-phone-repairs';
  }
      
  if(store.name=="Cardiff St Davids (Sky)"){
    selectStore.href = 'https://www.ismash.com/pages/ismash-cardiff-st-davids-sky';
  }
  
  if(store.name=='Liverpool One (Sky)'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-liverpool-one';
  }
  
  if(store.name=='London Bridge Station'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-london-bridge';
  }
  
  if(store.name=='Glasgow Buchanan St (Sky)'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-glasgow-buchanan-street';
  }
  
  if(store.name==' Nottingham'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-nottingham-king-street';
  }
  
  if(store.name=='Bristol Cribbs Causeway (Sky)'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-bristol-cribbs';
  }
  
  if(store.name=='Edinburgh St James (Sky)'){
    selectStore.href = 'https://www.ismash.com/pages/ismash-edinburgh-princes-street';
  }

  selectStore.textContent = "View details";
  storeDetails.appendChild(selectStore);

  // var selectStore = document.createElement("a");
  // selectStore.classList.add("btn");
  // selectStore.href = "javascript:selectStore(" + JSON.stringify(store) + ")";
  // selectStore.textContent = "Select this store";
  // storeDetails.appendChild(selectStore);

  storeDetailsWrap.appendChild(storeDetails);

  var infoWindow = new google.maps.InfoWindow({
    content: storeDetailsWrap
  });
  // google.maps.event.addListener(infoWindow, "closeclick", function() {
  //   self.map.setZoom(6);
  //   self.map.setCenter({
  //     lat: 52.7040556,
  //     lng: -1.6913345
  //   });
  // });

  var self = this;
  marker.addListener(
    "click",
    (function(self, infoWindow, marker) {
      return function() {
        self.map.setZoom(15);
        self.map.setCenter(marker.getPosition());
        infoWindow.open(self.map, marker);
      };
    })(self, infoWindow, marker)
  );
  return marker;
};

//Initialise the Google Map
var mapInit = function() {
  var self = this;
  var mapEl = document.querySelector("[data-map]");
  if (!mapEl) {
    console.log("can't find map div");
    return;
  }
  self.map = new google.maps.Map(mapEl, {
    center: {
      lat: 52.7040556,
      lng: -1.6913345
    },
    zoom: 7
  });

  for (var i = 0; i < stores.length; i++) {
    var store = stores[i];
    if (!store.latitude || !store.longitude) {
      continue;
    }
    createStoreMarker(store);
  }
};

getStoresLocations();
